import { render, staticRenderFns } from "./MovePerson.vue?vue&type=template&id=94922a10&scoped=true&"
import script from "./MovePerson.vue?vue&type=script&lang=js&"
export * from "./MovePerson.vue?vue&type=script&lang=js&"
import style0 from "./MovePerson.vue?vue&type=style&index=0&id=94922a10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94922a10",
  null
  
)

export default component.exports